module.exports = __webpack_public_path__ + "img/center-info-structure8-1.aa5fa1b1.png";